import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { dealsService } from "./services/Deals.service";
import DealsTable from "./DealsTable";
import DealsForm from "./DealsForm";
import { toast } from "react-toastify";
import ConfirmationModal from "../../Shared/ConfirmationModal";
import { merchantsService } from "../Merchants/services/Merchants.service";

const initialFetchingState = {
  fetching: false,
  fetched: false,
  data: null,
  error: null,
  filterParams: null,
  pages: null,
  pageNum: 0,
  pageSize: 10,
  imageUrl: null,
  action: null
};

const initialSubmitState = {
  submitting: false,
  submitted: false,
  formResponse: null,
  formError: null,
  hasParams: false,
  isView: false,
  action: null
};

const initailGetState = {
  fetchingRow: false,
  fetchedRow: false,
  fetchingError: null,
  selectedRow: null
};

const initailDeleteState = {
  deletingRow: false,
  deletedRow: false,
  deleteError: null,
  deleteResponse: null
};

const initailLocationState = {
  fetchingLocations: false,
  locationsFetched: false,
  merchantLocations: null,
  fetchLocationsError: null
};

class ManageDeals extends Component {
  state = {
    ...initialFetchingState,
    ...initialSubmitState,
    ...initailGetState,
    ...initailDeleteState,
    ...initailLocationState,
    isDeleteButton: false
  };

  componentDidMount() {
    const { pageNum, pageSize } = this.state;
    this.getAll({ pageNum: pageNum + 1, pageSize });
  }

  getAll = async params => {
    this.setState({
      ...this.state,
      fetching: true
    });
    try {
      let response = await dealsService.getAllDeals(params);
      if (response) {
        this.setState({
          ...this.state,
          fetching: false,
          fetched: true,
          data: response,
          pages: Math.ceil(response.count / params.pageSize),
          error: null
        });
      }
    } catch (error) {
      this.setState({
        ...this.state,
        fetching: false,
        fetched: false,
        error
      });
    }
  };

  addDeal = async requestBody => {
    
    const { pageSize, selectedRow } = this.state;

    this.setState({
      ...this.state,
      submitting: true,
      submitted: false,

      formResponse: null,
      formError: null
    });

  
    try {
      let response = await dealsService.addDeals(
        requestBody,
        selectedRow && selectedRow.id
      );
      if (response) {
        this.setState({
          ...this.state,
          submitting: false,
          submitted: true,
          formResponse: response,
          formError: null
        });
        this.getAll({ pageNum: 1, pageSize });
        this.resetButton();
        if (!selectedRow) {
          toast.success("Deal created successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000
          });
        } else {
          toast.success("Deal updated successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000
          });
          this.resetButton();
        }
      }
    } catch (error) {
      this.setState({
        ...this.state,
        formError: error,
        submitting: false
      });
    }
  };

  fetchData = () => {
    const { pageNum, pageSize, filterParams } = this.state;
    let params = { pageNum: pageNum + 1, pageSize };
    if (filterParams) {
      params = { ...filterParams, ...params };
    }
    this.getAll(params);
  
  };

  setPageNumber = pageIndex => {
    this.setState({ pageNum: pageIndex }, () => this.fetchData());
  };

  setPageSize = (pageSize, pageIndex) => {
    this.setState({ pageSize, pageNum: pageIndex }, () => this.fetchData());
  };

  filterData = params => {
    this.setState({ filterParams: params, pageNum: 0 }, () => this.fetchData());
  };

  getMerchantLocations = async (selectedMerchant, isModification) => {
    const merchantId = isModification ? selectedMerchant : selectedMerchant.id;
    const locationCall = isModification
      ? dealsService.getAllDealLocations(merchantId, {
          pageNum: 0,
          pageSize: 999
        })
      : merchantsService.getAllMerchantLocations(merchantId, {
          pageNum: 0,
          pageSize: 999
        });
    this.setState({
      ...this.state,
      fetchingLocations: true
    });
    try {
      let response = await locationCall;
      if (response) {
        this.setState({
          ...this.state,
          fetchingLocations: false,
          locationsFetched: true,
          merchantLocations: response,
          fetchLocationsError: null
        });
      }
    } catch (error) {
      this.setState({
        ...this.state,
        fetchingLocations: false,
        locationsFetched: false,
        fetchLocationsError: error
      });
    }
  };

  getDeal = async (params, action) => {
    this.setState({
      isDeleteButton: false,
      ...this.state,
      ...initialSubmitState,
      fetchingRow: true,
      fetchingError: null
    });
    try {
      let response = await dealsService.getDeal(params);

      if (response && response.data) {
        this.setState(
          {
            ...this.state,
            ...initialSubmitState,
            fetchingRow: false,
            fetchedRow: true,
            hasParams: true,
            isView: action === "view" ? true : false,
            selectedRow: response.data,
            isDeleteButton: false,
            action: action,
            imageUrl: response.data.imageUrl ? response.data.imageUrl : null
          },
          () => {
            this.getMerchantLocations(this.state.selectedRow.id, true);
          }
        );
      }
    } catch (error) {
      this.setState({
        ...this.state,
        ...initialSubmitState,
        fetchingRow: false,
        fetchedRow: false,
        fetchingError: error,
        selectedRow: null
      });
    }
  };

  selectRow = (selectedRow, action) => {
    this.getDeal(selectedRow.original.id, action);
  };

  resetButton = () => {
    this.setState({
      ...initailLocationState,
      hasParams: false,
      submitting: false,
      selectedRow: null,
      submitted: false,
      isView: false,
      isDeleteButton: true
    });
  };

  showConfirmation = selectedRow => {
    if (this.state.showModal) {
      this.setState({
        showModal: !this.state.showModal
      });
    } else {
      this.setState({
        selectedRow: selectedRow.original,
        showModal: !this.state.showModal
      });
    }
  };

  deleteDeal = item => {
    if (item.id) {
      dealsService
        .deleteDeal(item.id)
        .then(response => {
          this.setState({
            response,
            error: null,
            submitting: false,
            deletingRow: false,
            deletedRow: true,
            deleteError: null,
            showModal: false,
            hasParams: false,
            selectedRow: null,
            submitted: false,
            isView: false,
            isDeleteButton: true
          });
          this.fetchData();
          toast.success("Deal deleted successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000
          });
        })
        .catch(error =>
          this.setState({ formError: error, submitting: false }, () => {
            toast.error(this.state.formError.message, {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 4000
            });
          })
        );
    }
    this.setState({
      showModal: !this.state.showModal
    });
  };

  setImageNull = () => {
    this.setState({ imageUrl: null });
  };

  render() {
    const {
      fetching,
      fetched,
      data,
      pages,
      pageNum,
      pageSize,
      error,
      submitting,
      submitted,
      hasParams,
      selectedRow,
      formError,
      deletingRow,
      deletedRow,
      deleteError,
      deleteResponse,
      isView,
      imageUrl,
      fetchedRow,
      fetchingError,
      fetchingRow,
      isDeleteButton,
      fetchingLocations,
      locationsFetched,
      merchantLocations,
      fetchLocationsError,
      action
    } = this.state;

    const locationState = {
      loading: submitting,
      submitted: submitted,
      error,
      hasParams
    };

    const fetchingLocationState = {
      loading: fetchingLocations,
      fetched: locationsFetched,
      response: merchantLocations,
      error: fetchLocationsError
    };

    return (
      <Row>
        <Col sm="4">
          <DealsForm
            submitting={submitting}
            error={formError}
            hasParams={hasParams}
            selectedRow={selectedRow}
            getMerchantLocations={this.getMerchantLocations}
            submitAction={this.addDeal}
            reset={this.resetButton}
            submitted={submitted}
            isView={isView}
            imageUrl={imageUrl}
            locationState={locationState}
            locationViewState={fetchingLocationState}
            setImageNull={this.setImageNull}
            fetchedRow={fetchedRow}
            fetchingError={fetchingError}
            fetchingRow={fetchingRow}
            isDeleteButton={isDeleteButton}
            action={action}
          />
        </Col>
        <Col sm="8">
          <DealsTable
            fetching={fetching}
            fetched={fetched}
            data={data}
            pages={pages}
            page={pageNum}
            pageSize={pageSize}
            error={error}
            filterData={this.filterData}
            DeleteModal={this.DeleteModal}
            deleteRow={this.deleteDeal}
            showModal={this.showConfirmation}
            setPageNumber={this.setPageNumber}
            setPageSize={this.setPageSize}
            selectRow={this.selectRow}
            routeChange={this.routeChange}
          />
        </Col>
        <ConfirmationModal
          isOpen={this.state.showModal}
          showModal={this.showConfirmation}
          action={this.deleteDeal}
          actionState={{
            sending: deletingRow,
            sent: deletedRow,
            error: deleteError,
            response: deleteResponse
          }}
          item={selectedRow}
        />
      </Row>
    );
  }
}

export default ManageDeals;
